export { default } from './CollectionsUsingDefaultRuleModal';
